import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import tpp from './../img/tpp.gif';

export default () => {
    const title = 'Деловой туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вообще-то, это не туризм. Но так как в силу специфики своей работы, туристические фирмы более
                        всего подходят для организации деловых поездок, такой вид туризма как бы и имеет место.</p>
                </div>
                <div className="pageitem">
                    <div className="two-col-cell">
                        <h3>Услуги:</h3>
                        <ul>
                            <li>бронирование отелей по всему миру,</li>
                            <li>оформления виз и медицинской страховки,</li>
                            <li>продажа авиабилетов различных авиакомпаний,</li>
                            <li>аренда автомобилей различных классов,</li>
                            <li>трансферы с русскоговорящими гидами из аэропортов или с вокзалов,</li>
                            <li>экскурсии на русском языке,</li>
                            <li>организация деловых встреч и переговоров,</li>
                            <li>услуги профессиональных переводчиков,</li>
                            <li>мобильная международная связь (e-mail, телефон, факс), копировальная техника.</li>
                        </ul>
                    </div>
                    <div className="two-col-cell">
                        {<a href="https://tpp.brestobl.com/"><img src={tpp} alt='Торгово-промышленная палата Брестской области'/></a>}
                    </div>
                </div>
            </div>
        </>
    );
}